import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';
import axios from 'axios'
// import {API_ENDPOINT} from "../../../constants/config";

async function getData(groupId) {
    let key = `gr_uu_w_${groupId}`;
    if (window[key] != undefined) {
        let u = window[key];
        return u;
    }
    let pld = (await axios.get(`/v3/chat/group/${groupId}/messages-number`)).data;
    window[key] = pld;
    return pld;
}

export default function ChatMessagesNumberSpan(props) {
    const {
        groupId
    } = props;

    useEffect(() => {
        getData(groupId).then(x => {
            setData(x);
        })
    }, [groupId]);

    const [data, setData] = useState(undefined);
    if (data == undefined) {
        return '...';
    }
    // let name = CommonHelper.getUserName(user);
    // let name = user?.name || user?.email || '';
    let n = data?.n;
    if (n == undefined || n == 0){
        return null;
    }

    return (
        <Wrapper>
            {n}
        </Wrapper>
    );
}

const Wrapper = styled.span`
  color: black;
  font-size: 12px;
  opacity: 0.7;
  padding: 3px;
  padding-left: 10px;
`;